import HeaderComponent from '../../../../libs/components/header'
import { Body } from '../../../../libs/components/header/Header.styled'
import Metadata from '@App/libs/components/Metadata.component'
import { PageTypeEnum } from '@App/libs/interfaces'
import { EditoriaHeader } from '@App/pages/404'
import { PaginationContainer } from '@App/libs/style/search.style'
import { Separator } from '@App/libs/components/Separator'
import BannerCard from '@App/libs/components/jurisprudente-card'
import {
    GetServerSidePropsResult,
    GetServerSidePropsContext,
    NextPage
} from 'next/types'
import {
    CoberturasProps,
    FooterIH,
    HeaderIH
} from '../../../../libs/interfaces'
import {
    CardDS,
    FooterComponent,
    PaginationDS
} from '../../../../libs/components'
import {
    CECPosts,
    CECPostsHighlights,
    CECPostsIndividual,
    MultipleLogos,
    MultipleLogosContainer
} from '@App/libs/style/coberturas-especiais.style'
import BreadcrumbComponentJU, {
    BreadHome
} from '@App/libs/components/ds/Breadcrumb'
import {
    API_HEADER_FOOTER,
    getDataFromCoberturasEspeciaisChild
} from '@App/api/api'
import {
    ApiResponseCoberturasEspeciais,
    HeaderCoberturasEspeciaisChild
} from '@App/libs/interfaces/PRO.interfaces'
import {
    ListLogosCoberturas,
    PatrocinioMaster
} from '@App/libs/components/CoberturasEspeciaisLogos'

const CoberturasEspeciaisPage: NextPage<{
    header: HeaderIH
    footer: FooterIH
    coberturas: CoberturasProps
    total: any
    coberturaHeader: HeaderCoberturasEspeciaisChild
    posts: ApiResponseCoberturasEspeciais['content']['posts']
    totalPages: number
    currentPage: number
}> = ({ header, footer, coberturaHeader, posts, totalPages, currentPage }) => {
    const pageName = 'Coberturas Especiais'
    const {
        isActive,
        master = [],
        normal = [],
        apoio = []
    } = coberturaHeader?.multiple || {}
    const hasLogoContent: boolean =
        (master?.length ?? 0) > 0 ||
        (normal?.length ?? 0) > 0 ||
        (apoio?.length ?? 0) > 0
    const hasValidContent = Array.isArray(posts)

    return (
        <div className='page' data-page-type='categoria-coberturas-especiais'>
            <Metadata
                url={`/coberturas-especiais/${coberturaHeader.slug}`}
                title={`JOTA - ${pageName} - ${coberturaHeader.name}`}
                description={coberturaHeader.description}
                image={coberturaHeader.background_image}
                breadcrumb={[
                    BreadHome,
                    {
                        label: pageName,
                        slug: `/coberturas-especiais`,
                        clickable: true
                    },
                    {
                        label: coberturaHeader.name,
                        slug: `/coberturas-especiais/${coberturaHeader.slug}`,
                        clickable: true
                    }
                ]}
                pageType={PageTypeEnum.CATEGORY}
                pagination={{
                    page: currentPage,
                    totalPages: totalPages
                }}
            />

            <Body>
                {header && (
                    <HeaderComponent
                        wpMenu={header.menu}
                        ctaPRO={header.pro}
                        showAcessibility={header.enableAccessibility}
                        signupLink={header.assinePage}
                    />
                )}

                {hasValidContent && (
                    <EditoriaHeader>
                        <BreadcrumbComponentJU
                            items={[
                                BreadHome,
                                {
                                    label: 'Coberturas Especiais',
                                    slug: `/coberturas-especiais`,
                                    clickable: true
                                },
                                {
                                    label: coberturaHeader.name ?? 'Cobertura',
                                    slug: `/coberturas-especiais/${coberturaHeader.slug}`,
                                    clickable: false
                                }
                            ]}
                        />
                        <BannerCard
                            image={coberturaHeader?.background_image}
                            headerName={
                                coberturaHeader.name ?? 'Cobertura Especial'
                            }
                            headerDescription={
                                coberturaHeader?.description ?? ''
                            }
                            logo={
                                !hasLogoContent
                                    ? coberturaHeader?.company_logo
                                    : ''
                            }
                            relationType={coberturaHeader?.relation_type}
                            patrocinadoresMasterLogo={
                                coberturaHeader?.multiple?.master
                            }
                            patrocinadoPorLogo={
                                coberturaHeader?.multiple?.normal
                            }
                        />
                        <CECPosts>
                            <CECPostsHighlights>
                                {posts?.slice(0, 4).map((post) => {
                                    return (
                                        <CardDS
                                            key={post.id}
                                            title={post.title}
                                            titleSearchTerm={''}
                                            isVertical
                                            newsLink={() => {
                                                if (
                                                    typeof window !==
                                                    'undefined'
                                                ) {
                                                    window.open(
                                                        post.link,
                                                        '_self'
                                                    )
                                                }
                                            }}
                                            tagLabel={post.hat}
                                            tagDisableHover
                                            size='small'
                                            image={post.thumbnail}
                                            imageAlt={post.title}
                                            isSponsored
                                            relatedTagLabel={post.date}
                                            relatedTagDisableHover
                                            authorTagLabel={' '}
                                            multipleAuthors={[
                                                ...(Array.isArray(post.authors)
                                                    ? post.authors
                                                    : [])
                                            ]}
                                        />
                                    )
                                })}
                            </CECPostsHighlights>

                            <CECPostsIndividual>
                                {posts?.slice(4).map((post) => {
                                    return (
                                        <CardDS
                                            key={post.id}
                                            title={post.title}
                                            titleSearchTerm={''}
                                            isVertical={false}
                                            newsLink={() => {
                                                if (
                                                    typeof window !==
                                                    'undefined'
                                                ) {
                                                    window.open(
                                                        post.link,
                                                        '_self'
                                                    )
                                                }
                                            }}
                                            tagLabel={post.hat}
                                            tagDisableHover
                                            size='small'
                                            image={post.thumbnail}
                                            imageAlt={post.title}
                                            isSponsored
                                            relatedTagLabel={post.date}
                                            relatedTagDisableHover
                                            authorTagLabel={' '}
                                            multipleAuthors={[
                                                ...(Array.isArray(post.authors)
                                                    ? post.authors
                                                    : [])
                                            ]}
                                        />
                                    )
                                })}
                            </CECPostsIndividual>

                            <PaginationContainer>
                                <PaginationDS
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    handleChange={(
                                        e: any,
                                        currentPage: number
                                    ) => {
                                        window.open(
                                            `${window.location.pathname}?page=${currentPage}`,
                                            '_self'
                                        )
                                    }}
                                    color='jotaOrange'
                                />
                            </PaginationContainer>
                        </CECPosts>

                        {isActive && hasLogoContent && (
                            <>
                                <MultipleLogosContainer>
                                    <Separator marginTop='0' />
                                    <MultipleLogos>
                                        {master?.length > 0 && (
                                            <ListLogosCoberturas
                                                sponsors={master}
                                                label={PatrocinioMaster}
                                            />
                                        )}
                                        {normal.length > 0 && (
                                            <ListLogosCoberturas
                                                sponsors={normal}
                                                label='Patrocinadores'
                                            />
                                        )}
                                    </MultipleLogos>

                                    <Separator />

                                    {apoio?.length > 0 && (
                                        <ListLogosCoberturas
                                            sponsors={apoio}
                                            label='Apoiadores'
                                        />
                                    )}
                                </MultipleLogosContainer>
                                <Separator />
                            </>
                        )}
                    </EditoriaHeader>
                )}

                {footer && <FooterComponent footer={footer} />}
            </Body>
        </div>
    )
}

export default CoberturasEspeciaisPage

/**
 * getServerSideProps
 * @param {unknown} context
 * @return {Promise<GetServerSidePropsResult<HomePagePropsInterface>>}
 */
export async function getServerSideProps(
    context: GetServerSidePropsContext<{ slug: string }>
): Promise<GetServerSidePropsResult<any>> {
    const slug = context.params?.slug as string
    const pageParam = Number(context.query?.page) || 1

    if (!API_HEADER_FOOTER) {
        throw new Error('API_HEADER_FOOTER is not defined')
    }

    context.res.setHeader(
        'Cache-Control',
        'public, s-maxage=1800, stale-while-revalidate=1800'
    )

    let resHeaderFooter
    let dataCobertura

    try {
        ;[resHeaderFooter, dataCobertura] = await Promise.all([
            fetch(API_HEADER_FOOTER, { cache: 'no-cache' }),
            getDataFromCoberturasEspeciaisChild(slug, pageParam)
        ])
    } catch (error) {
        console.error('Failed to fetch page data:', error)
        return {
            notFound: true
        }
    }

    const { header, footer } = await resHeaderFooter.json()
    const posts = dataCobertura.content.posts || []
    const totalPages = dataCobertura.content.total_page || 1

    return {
        props: {
            header,
            footer,
            coberturaHeader: dataCobertura.header,
            posts,
            totalPages,
            currentPage: pageParam
        }
    }
}
